// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"43":"f518a403","80":"a101f72c","163":"0420a299","187":"f9f6b9f5","211":"3d04d231","376":"606955da","381":"f9f6b9f5","726":"a30b382c","967":"0420a299"}[chunkId] + ".chunk.css";
};